export { codeBlockLangAttr as langAttr, codeBlockNodeName } from '../../../extensions/markdown';
